import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const RedirectAuthenticated = ({
	path,
	location,
	isAuthenticated,
	willAuthenticate,
	component: Component,
}: Props) =>
{
	if (isAuthenticated ){
		return( 
			<Redirect to={{ pathname: '/library' }} /> 
		)
	} 

	else if(!isAuthenticated && !willAuthenticate){
		return(	
			<Route
		 		exact
		 		path={path}
		 		render={(props) => {
		 			 if (typeof window.ga === 'function') {
						    window.ga('set', 'page',  location.pathname + location.search)
						    window.ga('send', 'pageview')
  						}
		 			return <Component {...props} /> }}
			/>
			
		)

	}
	else return null

}

export default RedirectAuthenticated



// WEBPACK FOOTER //
// ./src/components/routing/RedirectAuthenticated.js